"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var SignatureSlot_1 = require("../EsignComponents/SignatureSlot");
var Signature_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Signature");
var inversify_react_1 = require("inversify-react");
var AcceptersDataStore_1 = require("@CommonFrontend/AcceptFlow/AcceptersDataStore");
var DIProvider_1 = __importStar(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var mobx_react_1 = require("mobx-react");
var AcceptFlowGlobalStore_1 = __importDefault(require("@CommonFrontend/AcceptFlow/AcceptFlowGlobalStore"));
var styles = __importStar(require("./Signature.css"));
var SignatureWidget = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var attributes = _a.attributes;
    var handleChangeSignature = function (data, index) {
        acceptStore.updateSlotSignature(index, data.signature);
    };
    var handleClearSignature = function (index) {
        acceptStore.clearSlot(index);
    };
    var acceptStore = (0, inversify_react_1.useInjection)("acceptersDataStore");
    var showName = acceptStore.accepterSlots.length > 1 ||
        (acceptStore.accepterSlots.length === 1 && ((_b = acceptStore.accepterSlots[0]) === null || _b === void 0 ? void 0 : _b.name) !== "Accepter A");
    var storeIndex = AcceptFlowGlobalStore_1.default.getInstance().getAllDataStores().indexOf(acceptStore);
    return (react_1.default.createElement(Signature_1.SignatureWidgetContainer, { attributes: attributes }, acceptStore.accepterSlots.map(function (accepter, index) {
        var _a;
        return (react_1.default.createElement("div", { id: "agreement-initials-signature-".concat(storeIndex, "-").concat(index), key: index, className: styles.signatureSlotContainer({ filled: !!accepter.signature }) },
            react_1.default.createElement(SignatureSlot_1.SignatureSlot, { name: accepter.name, showName: showName, data: (_a = accepter.signature) !== null && _a !== void 0 ? _a : null, onClear: function () { return handleClearSignature(index); }, onChange: function (data) { return handleChangeSignature(data, index); }, type: SignatureSlot_1.SlotType.Signature, dateStamp: accepter.acceptedAt, isEditable: !accepter.isAccepted && !AcceptFlowGlobalStore_1.default.getInstance().isSlotLockedInAnyStore(index), isCritical: accepter.isCritical })));
    })));
});
var WrappedSignatureWidget = function (_a) {
    var attributes = _a.attributes, di = _a.di;
    var isClientSide = typeof document !== "undefined";
    if (!isClientSide) {
        return null;
    }
    var container = new inversify_1.Container({ skipBaseClassChecks: true });
    var acceptersDataStore = new AcceptersDataStore_1.AcceptersDataStore(di.get("$rootScope"));
    container.bind("acceptersDataStore").toConstantValue(acceptersDataStore);
    AcceptFlowGlobalStore_1.default.getInstance().registerDataStore(acceptersDataStore);
    return (react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
        react_1.default.createElement(DIProvider_1.default, { container: function () { return container; } },
            react_1.default.createElement(SignatureWidget, { attributes: attributes }))));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(WrappedSignatureWidget, { componentName: "SignatureWidget" });
